import type { AdvancedThreshold, ThresholdColor } from "@/overlay/components/CommonParts/Threshold/types";
import type { PoiDataGrid } from "@/threads/DataProcessingThread/types";
import type { PartialWeatherParameter } from "@mm/weather-parameter-utils";
import * as weatherParamUtil from "@mm/weather-parameter-utils";

function parseCoordinate(value: unknown): number | null {
  if (value == null || value === "") {
    return null;
  }

  const parsed = typeof value === "number" ? value : Number.parseFloat(String(value).trim());
  return Number.isFinite(parsed) ? parsed : null;
}

function isValidLocationRow(row: PoiDataGrid[number]): boolean {
  const lat = parseCoordinate(row.lat);
  const lon = parseCoordinate(row.lon);

  return lat !== null && lon !== null && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
}

export function isAddAlertLayerFormValid({
  title,
  locations,
  currentParam,
  thresholds,
  advancedThresholds: _advancedThresholds,
}: {
  title: string;
  locations: PoiDataGrid;
  currentParam: PartialWeatherParameter | null;
  thresholds: ThresholdColor[];
  advancedThresholds: AdvancedThreshold[];
}): boolean {
  const hasTitle = title.trim().length > 0;
  const hasLocation = locations.some(isValidLocationRow);
  const hasParameter = !!currentParam && !!weatherParamUtil.parameterToString(currentParam)?.formatted;
  const hasThreshold = thresholds.length > 0;

  return hasTitle && hasLocation && hasParameter && hasThreshold;
}
